/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {SpecialOrderPositionValidationResultModel} from '../../../api/ms-specialorders/contracts/special-order-position-validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class ExcelUploadService {
    private validMaterialsSubject = new Subject<SpecialOrderPositionValidationResultModel[]>();
    private invalidMaterialsSubject = new Subject<SpecialOrderPositionValidationResultModel[]>();

    constructor() {
    }

    set validMaterials(materials: SpecialOrderPositionValidationResultModel[]) {
        this.validMaterialsSubject.next(materials);
    }

    set invalidMaterials(materials: SpecialOrderPositionValidationResultModel[]) {
        this.invalidMaterialsSubject.next(materials);
    }

    get validMaterialsChange(): Observable<SpecialOrderPositionValidationResultModel[]> {
        return this.validMaterialsSubject.asObservable();
    }

    get invalidMaterialsChange(): Observable<SpecialOrderPositionValidationResultModel[]> {
        return this.invalidMaterialsSubject.asObservable();
    }
}
